// extracted by mini-css-extract-plugin
module.exports = {"responsive":"Image_responsive__nK4de","cover":"Image_cover__g9RBY","background":"Image_background__qKwDu"};